import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface IEmailTemplateState {
  emailTemplateDetail: IObjectState<any>
}

export const prefix = "template/attention"

export const state = (): IEmailTemplateState => ({
  emailTemplateDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return state.emailTemplateDetail.data || {}
  },
}

export const mutations = {
  updateDetail: (state: IEmailTemplateState, data) => {
    Vue.set(state, "emailTemplateDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.emailTemplateDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(
          state.emailTemplateDetail,
          response.data
        )
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(
          state.emailTemplateDetail,
          e.response?.data || e
        )
      )
    }
  },
}
